<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout wrap>
      <v-flex md12>
        <div>
          <material-card
            color="primary"
            title="Unmatched Homes">
            <v-spacer />
            <v-text-field
              v-model="searchHome"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            />
            <v-dialog
              v-model="dialogHomeEdit"
              max-width="400px">
              <v-card>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-text-field
                        v-model="editedHomeItem.home_id"
                        label="Home Id"
                        disabled
                      />
                      <v-autocomplete
                        v-model="editedHomeItem.deviceSelect"
                        :items="orphanDevices"
                        dense
                        label="Unmatched Devices"
                      />
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    @click="closeHomeEdit"
                  >Cancel</v-btn
                  >
                  <v-btn
                    color="green darken-1"
                    @click="editHome">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-data-table
              :headers="headersHomeList"
              :items="HomeList"
              :search="searchHome"
              class="dashboard-tables"
              hide-actions
            >
              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <!-- <td>{{ props.item.id }}</td> -->
                <td class="">{{ props.item.home_id }}</td>
                <td class="">{{ props.item.name ? props.item.name : '-' }}</td>
                <td class="">{{ props.item.address ? props.item.address  : '-'}}</td>
                <td class="">{{ props.item.supply_number ? props.item.supply_number : '-' }}</td>
                <!-- <td class="">
                  {{
                    props.item.tags !== null ? props.item.tags.toString() : "-"
                  }}
                </td> -->
                <td class="justify-center ">
                  <v-icon
                    medium
                    class="mr-2"
                    @click="editHomeItem(props.item)"
                  >mdi-server-plus</v-icon
                  >
                </td>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="3000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>
      <v-flex md12>
        <div>
          <material-card
            color="primary"
            title="Unmatched Devices">
            <v-spacer />
            <v-text-field
              v-model="searchDevice"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            />
            <v-dialog
              v-model="dialogDeviceEdit"
              max-width="400px">
              <v-card>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-text-field
                        v-model="editedDeviceItem.deviceid"
                        label="Device Id"
                        disabled
                      />
                      <v-autocomplete
                        v-model="editedDeviceItem.homeSelect"
                        :items="allHomes"
                        dense
                        item-text="readable_address"
                        item-value="home_id"
                        label="All Homes"
                      />
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    @click="closeDeviceEdit"
                  >Cancel</v-btn
                  >
                  <v-btn
                    color="green darken-1"
                    @click="editDevice">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-data-table
              :headers="headersDeviceList"
              :items="DeviceList"
              :search="searchDevice"
              class="dashboard-tables"
              hide-actions
            >
              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <!-- <td>{{ props.item.id }}</td> -->
                <td class="">{{ props.item.deviceid }}</td>
                <td class="">{{ props.item.device_name }}</td>
                <td class="">{{ props.item.device_type_text }}</td>
                <!-- <td class="">
                  {{
                    props.item.tags !== null ? props.item.tags.toString() : "-"
                  }}
                </td> -->
                <td class="">{{ formatDate(props.item.registeredat) }}</td>
                <td class="justify-center ">
                  <v-icon
                    medium
                    class="mr-2"
                    @click="editDeviceItem(props.item)"
                  >mdi-home-plus</v-icon
                  >
                </td>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="3000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>
      <v-flex md12>
        <div>
          <material-card
            color="primary"
            title="Homeless Users">
            <v-spacer />
            <v-text-field
              v-model="searchUser"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            />

            <v-dialog
              v-model="dialogUserEdit"
              max-width="950px">
              <v-card>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex
                        xs12
                        sm6
                        md4>
                      <v-text-field
                        v-model="addedItem.user_email"
                        label="Home Id"
                        disabled
                      />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="addedItem.address"
                          required
                          label="Address (Required)"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="addedItem.name"
                          label="Home Name (Optional)"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-text-field
                          v-model="addedItem.home_id"
                          label="Home Id (Auto-generated if not provided)"
                          @keypress="isNumber()"
                        />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    @click="closeUserEdit">Cancel</v-btn>
                  <v-btn
                    color="green darken-1"
                    @click="addHome">Add</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-data-table
              :headers="headersUserList"
              :items="UserList"
              :search="searchUser"
              class="dashboard-tables"
              hide-actions
            >
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <td class="">
                  {{
                    props.item.firstname !== null && props.item.firstname !== ""
                      ? props.item.firstname
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.lastname !== null && props.item.lastname !== ""
                      ? props.item.lastname
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.email !== null && props.item.email !== ""
                      ? props.item.email
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.address !== null && props.item.address !== ""
                      ? props.item.address
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.phone !== null && props.item.phone !== ""
                      ? props.item.phone
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.afm !== null && props.item.afm !== ""
                      ? props.item.afm
                      : "-"
                  }}
                </td>
                <td class="justify-center ">
                  <v-icon
                    medium
                    class="mr-2"
                    @click="editUserItem(props.item)"
                  >mdi-home-plus</v-icon
                  >
                </td>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="3000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    pagination: {},
    DeviceList: [],
    orphanDevices: [],
    UserList: [],
    unmatchedUsers: [],
    HomeList: [],
    AllHomesList: [],
    unmatchedHomes: [],
    allHomes: [],
    rowsAmount: [
      10,
      15,
      20,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    dialogDeviceEdit: false,
    dialogUserEdit: false,
    dialogHomeEdit: false,
    searchDevice: '',
    searchHome: '',
    searchUser: '',
    headersDeviceList: [
      { text: 'Id', value: 'id', align: ' d-none' },
      { text: 'Device Id', value: 'deviceid' },
      { text: 'Device Name', value: 'device_name' },
      { text: 'Device Type', value: 'device_type_text' },
      { text: 'Registered At', value: 'registeredat' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],
    headersHomeList: [
      { text: 'Id', value: 'id', align: ' d-none' },
      { text: 'HomeId', value: 'home_id' },
      { text: 'Name', value: 'name' },
      { text: 'Address', value: 'address' },
      { text: 'Supply Number', value: 'supply_number' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],
    headersUserList: [
      { text: 'Id', value: 'id', align: ' d-none' },
      { text: 'First Name', value: 'firstname' },
      { text: 'Last Name', value: 'lastname' },
      { text: 'Email', value: 'email', sortable: false },
      { text: 'Address', value: 'address', sortable: false },
      { text: 'Phone', value: 'phone' },
      { text: 'ΑΦΜ', value: 'afm' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],
    editedDeviceIndex: -1,
    editedDeviceItem: {
      deviceid: '',
      userSelect: []
    },
    editedHomeIndex: -1,
    editedHomeItem: {
      homeid: '',
      deviceSelect: []
    },
    editedUserIndex: -1,
    editedUserItem: {
      email: '',
      deviceSelect: []
    },
    addedItem: {
      home_id: null,
      address: '',
      user_email: '',
      name: ''
    },
    defaultItem: {}
  }),

  watch: {
    dialogDeviceEdit (val) {
      val || this.closeDeviceEdit()
    },
    dialogHomeEdit (val) {
      val || this.closeHomeEdit()
    },
    dialogUserEdit (val) {
      val || this.closeUserEdit()
    }
  },

  // called when page is created before dom
  created () {
    this.getOrphanDevices()
    this.getUnmatchedUsers()
    this.getUnmatchedHomes()
    this.getHomes();
  },

  methods: {
    getOrphanDevices () {
      this.$http
        .get('devices/orphans')
        .then((response) => {
          this.DeviceList = response.data
          this.orphanDevices = []
          for (var i = 0; i < response.data.length; i++) {
            this.orphanDevices.push(response.data[i].deviceid)
          }
        })
        .catch((error) => console.log(error))
    },

    getUnmatchedUsers () {
      this.$http
        .get('admin/users/childless')
        .then((response) => {
          this.UserList = response.data
          this.unmatchedUsers = []
          for (var i = 0; i < response.data.length; i++) {
            this.unmatchedUsers.push(response.data[i].email)
          }
        })
        .catch((error) => console.log(error))
    },

    getUnmatchedHomes () {
      this.$http
        .get('admin/homes/childless')
        .then((response) => {
          this.HomeList = response.data
          this.unmatchedHomes = []
          for (var i = 0; i < response.data.length; i++) {
            this.unmatchedHomes.push(response.data[i])
          }
        })
        .catch((error) => console.log(error))
    },

    getHomes () {
      this.$http
        .get('homes')
        .then((response) => {
          this.AllHomesList = response.data
          this.allHomes = []
          for (var i = 0; i < response.data.length; i++) {
            response.data[i].readable_address = `${response.data[i].email} | ${response.data[i].name} | ${response.data[i].address}`
            this.allHomes.push(response.data[i])
          }
        })
        .catch((error) => console.log(error))
    },

    formatDate (datetime) {
      return moment(datetime).format('MMM DD, YYYY HH:mm:ss')
    },

    formatDeviceType (type) {
      let deviceTypeString = 'Single Phase'
      if (type == 1) {
        return 'Single Phase'
      } else if (type == 2) {
        return 'Three Phase'
      }
    },

    // EDIT DEVICE

    editDeviceItem (item) {
      this.editedDeviceIndex = this.DeviceList.indexOf(item)
      this.editedDeviceItem = Object.assign({}, item)
      this.dialogDeviceEdit = true
    },

    editHomeItem (item) {
      this.editedHomeIndex = this.HomeList.indexOf(item)
      this.editedHomeItem = Object.assign({}, item)
      this.dialogHomeEdit = true
    },


    closeDeviceEdit () {
      this.dialogDeviceEdit = false
      this.$nextTick(() => {
        this.editedDeviceItem = Object.assign({}, this.defaultItem)
        this.editedDeviceItem = -1
      })
    },

    closeHomeEdit () {
      this.dialogHomeEdit = false
      this.$nextTick(() => {
        this.editedHomeItem = Object.assign({}, this.defaultItem)
        this.editedHomeItem = -1
      })
    },

    editDevice () {

      if (
        this.editedDeviceItem.homeSelect == '' ||
        this.editedDeviceItem.homeSelect == undefined
      ) {
        this.requiredUserInline()
      } else {
        let objectForEditDevice = {}
        objectForEditDevice.device_count = this.editedDeviceItem.homeSelect

        let endpoint = `devices/${this.editedDeviceItem.deviceid}`
        let method = 'patch'
        let tableItem = objectForEditDevice
        this.$store
          .dispatch('editDevice', { endpoint, tableItem, method })
          .then((response) => {
            this.saveInline()
            this.getOrphanDevices()
            this.getUnmatchedUsers()
            this.getUnmatchedHomes()
            this.getHomes()
          })
          .catch((error) => {
            console.log(error)
            this.apiErrorInline()
          })

        this.closeDeviceEdit()
      }
    },

    editHome () {

          // editedHomeItem: {
          //   homeid: '',
          //   deviceSelect: []
          // },

      if (
        this.editedHomeItem.deviceSelect == '' ||
        this.editedHomeItem.deviceSelect == undefined
      ) {
        this.requiredHomeInline()
      } else {
        let objectForEditDevice = {}
        objectForEditDevice.device_count = this.editedHomeItem.home_id

        let endpoint = `devices/${this.editedHomeItem.deviceSelect}`
        let method = 'patch'
        let tableItem = objectForEditDevice
        this.$store
          .dispatch('editHome', { endpoint, tableItem, method })
          .then((response) => {
            this.saveInline()
            this.getOrphanDevices()
            this.getUnmatchedUsers()
            this.getUnmatchedHomes()
            this.getHomes()
          })
          .catch((error) => {
            console.log(error)
            this.apiErrorInline()
          })

        this.closeHomeEdit()
      }
    },

    // EDIT USER

    editUserItem (item) {
      this.addedItem.user_email = item.email
      // this.addedItem = Object.assign({}, item)
      this.dialogUserEdit = true
    },

    closeUserEdit () {
      this.dialogUserEdit = false
      this.$nextTick(() => {
        this.editedUserItem = Object.assign({}, this.defaultItem)
        this.editedUserItem = -1
      })
    },

    editUser () {
      if (
        this.editedUserItem.deviceSelect == '' ||
        this.editedUserItem.deviceSelect == undefined
      ) {
        this.requiredDeviceInline()
      } else {
        let objectForEditDevice = {}
        objectForEditDevice.user_email = this.editedUserItem.email

        let endpoint = `devices/${this.editedUserItem.deviceSelect}`
        let method = 'patch'
        let tableItem = objectForEditDevice
        this.$store
          .dispatch('editDevice', { endpoint, tableItem, method })
          .then((response) => {
            this.saveInline()
            this.getUnmatchedUsers()
            this.getOrphanDevices()
            this.getUnmatchedHomes()
          })
          .catch((error) => {
            console.log(error)
            this.apiErrorInline()
          })

        this.closeUserEdit()
      }
    },

    addHome () {
      if (
        this.addedItem.address == '' ||
        this.addedItem.address == undefined ||
        this.addedItem.user_email == '' ||
        this.addedItem.user_email == undefined ||
        this.addedItem.name == '' ||
        this.addedItem.name == undefined
      ) {
        this.requiredInline()
      }
      else {
        let objectForAddDevice = {}

        if (this.addedItem.home_id !== null) {
          objectForAddDevice.home_id = this.addedItem.home_id
        }

        objectForAddDevice.address = this.addedItem.address

        objectForAddDevice.user_email = this.addedItem.user_email
        objectForAddDevice.name = this.addedItem.name

        let endpoint = `homes`
        let method = 'post'
        let tableItem = objectForAddDevice
        this.$store
          .dispatch('addHome', { endpoint, tableItem, method })
          .then((response) => {
            this.saveInline()
            this.getUnmatchedUsers()
            this.getOrphanDevices()
            this.getUnmatchedHomes()
          })
          .catch((error) => {
            // console.log(error.response.status);
            this.apiErrorInline()
          })

        this.closeAdd()
      }
    },

    closeAdd () {
      this.dialogUserEdit = false
      this.$nextTick(() => {
        this.addedItem = Object.assign({}, this.defaultItem)
      })
    },

    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'heron_success'
      this.snackText = 'Success'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    apiErrorInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Something went wrong'
    },
    requiredUserInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Please select user'
    },
    requiredHomeInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Please select device'
    },
    requiredDeviceInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Please select device'
    },
    reset () {
      this.snack = true
      this.snackColor = 'heron_success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'heron_info'
      this.snackText = 'Dialog opened'
    },
    closeInline () {
      console.log('Dialog closed')
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.dashboard-tables {
  max-height: 40vh;
  overflow-y: auto;
}
</style>
